var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrossIncome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#B5E4CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4889 17.0534C21.376 16.5265 20.624 16.5264 20.5111 17.0534L19.3166 22.6279C19.0202 24.0111 17.7978 24.9993 16.3832 24.9993H15C14.4477 24.9993 14 24.5516 14 23.9993C14 23.447 14.4477 22.9993 15 22.9993H16.3832C16.8547 22.9993 17.2622 22.6699 17.361 22.2088L18.5555 16.6344C19.1201 13.9995 22.8799 13.9995 23.4445 16.6344L26.5111 30.9451C26.624 31.4721 27.376 31.4721 27.4889 30.9451L28.6834 25.3707C28.9798 23.9875 30.2022 22.9993 31.6168 22.9993H33C33.5523 22.9993 34 23.447 34 23.9993C34 24.5516 33.5523 24.9993 33 24.9993H31.6168C31.1453 24.9993 30.7378 25.3287 30.639 25.7898L29.4445 31.3642C28.8799 33.9991 25.1201 33.9991 24.5555 31.3642L21.4889 17.0534Z",
    fill: "#1A1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossIncome);
export default __webpack_public_path__ + "static/media/GrossIncome.2998add2776f21193c4e949188ffed22.svg";
export { ForwardRef as ReactComponent };